const initialState = {
  workflows: ["Call", "renew license", "make apointment"],
  dataSets: [],
  campaigns: [
    {
      name: "First campaign",
      workflow: "Call",
      dataset: "Example Dataset",
      datasetId: 1,
    },
  ],
  columnFilters: [],
  dataset: undefined,
  campaign: undefined,
};

export { initialState };
